export const GET_MAIN_SHAFT_PARALLEL_MISALIGNMENT_RESULT = "GET_MAIN_SHAFT_PARALLEL_MISALIGNMENT_RESULT";
export const GET_MAIN_SHAFT_PARALLEL_MISALIGNMENT_RESULT_SUCCESS =
	"GET_MAIN_SHAFT_PARALLEL_MISALIGNMENT_RESULT_SUCCESS";
export const GET_MAIN_SHAFT_PARALLEL_MISALIGNMENT_RESULT_ERROR = "GET_MAIN_SHAFT_PARALLEL_MISALIGNMENT_RESULT_ERROR";
export const RESET_MAIN_SHAFT_PARALLEL_MISALIGNMENT_RESULT = "RESET_MAIN_SHAFT_PARALLEL_MISALIGNMENT_RESULT";
export const GET_MAIN_SHAFT_PARALLEL_MISALIGNMENT_CHART = "GET_MAIN_SHAFT_PARALLEL_MISALIGNMENT_CHART";
export const GET_MAIN_SHAFT_PARALLEL_MISALIGNMENT_CHART_SUCCESS = "GET_MAIN_SHAFT_PARALLEL_MISALIGNMENT_CHART_SUCCESS";
export const GET_MAIN_SHAFT_PARALLEL_MISALIGNMENT_CHART_ERROR = "GET_MAIN_SHAFT_PARALLEL_MISALIGNMENT_CHART_ERROR";
